import { Types } from "../actions/advisorActions";
import _ from "lodash";

const advisorReducers = (state, action) => {
	switch (action.type) {
		case Types.ADVISORS_UPDATE_MEMBER_LIST: {
			let newState = _.cloneDeep(state);

			newState.advisors.team = action.payload;

			return newState;
		}

		case Types.ADVISORS_SET_INVITE_MODAL_STATUS: {
			let newState = _.cloneDeep(state);

			newState.advisors.inviteAdvisorModal = action.status;

			return newState;
		}

		case Types.ADVISORS_ADD_MEMBER_STATUS: {
			let newState = _.cloneDeep(state);

			newState.advisors.sendingInvite = action.status;

			return newState;
		}

		case Types.ADVISORS_SET_CREATE_MODAL_STATUS: {
			let newState = _.cloneDeep(state);

			newState.advisors.createAdvisorModal = action.status;

			return newState;
		}

		case Types.ADVISORS_EVERROLL_SETTINGS_MODAL: {
			let newState = _.cloneDeep(state);

			newState.advisors.everRollSettingsModal = action.status;

			return newState;
		}

		case Types.ADVISORS_SAVING_EVERROLL_SETTINGS: {
			let newState = _.cloneDeep(state);

			newState.advisors.savingEverRollSettings = action.status;

			return newState;
		}

		case Types.ADVISORS_NEW_STATUS: {
			let newState = _.cloneDeep(state);

			newState.advisors.creatingNew = action.status;

			return newState;
		}

		case Types.ADVISORS_UPDATING_DETAILS: {
			let newState = _.cloneDeep(state);

			newState.advisors.updatingDetails = action.status;

			return newState;
		}

		case Types.ADVISORS_SCHEDULED_PAYROLLS_LOADED: {
			let newState = _.cloneDeep(state);

			newState.advisors.scheduledPayrolls = action.data;

			return newState;
		}

		case Types.ADVISORS_EVERROLL_SETTINGS: {
			let newState = _.cloneDeep(state);

			newState.advisors.everRollSettings = action.payload;

			return newState;
		}

		case Types.ADVISORS_UPDATE_SETTINGS: {
			let newState = _.cloneDeep(state);

			newState.advisors.settings = action.payload;

			return newState;
		}

		case Types.ADVISORS_LOADED_LIST: {
			let newState = _.cloneDeep(state);

			newState.advisors.advisorList = action.payload;

			return newState;
		}

		case Types.ADVISORS_SCHEDULED_TASKS_LOADED: {
			let newState = _.cloneDeep(state);

			newState.advisors.scheduledTasks = action.data;

			return newState;
		}
		case Types.ADVISORS_PAYROLL_STATS_LOADED: {
			let newState = _.cloneDeep(state);

			newState.advisors.payroll = action.data;

			const orgById = {};

			newState.organisations.map((org) => {
				orgById[org.id] = org.name;
			})

			console.log('orgById',orgById)

			// add client name to each payroll
			newState.advisors.payroll.upcomingPayrolls.map((payroll) => {
				payroll.name = orgById[payroll.org];
			});

			newState.advisors.payroll.pastPayrolls.map((payroll) => {
				payroll.name = orgById[payroll.org];
			});

			return newState;
		}

		case Types.ADVISORS_SCHEDULED_TASK_PROCESSING: {
			let newState = _.cloneDeep(state);

			const taskIndex = newState.advisors.scheduledTasks.findIndex((t) => t.id === action.id);
			newState.advisors.scheduledTasks[taskIndex].processing = action.status;

			return newState;
		}


		case Types.ADVISORS_SCHEDULED_TASK_RUN_COMPLETE: {
			let newState = _.cloneDeep(state);

			const taskIndex = newState.advisors.scheduledTasks.findIndex((t) => t.id === action.task.id);
			newState.advisors.scheduledTasks[taskIndex] = action.task;

			return newState;
		}

		case Types.ADVISORS_SCHEDULED_TASK_DELETED: {
			let newState = _.cloneDeep(state);

			const taskIndex = newState.advisors.scheduledTasks.findIndex((t) => t.id === action.id);
			newState.advisors.scheduledTasks.splice(taskIndex, 1);


			return newState;
		}

		case Types.ADVISORS_UPDATE_CURRENT: {
			let newState = _.cloneDeep(state);

			const advisor = newState.advisors.advisorList.find((a) => a.id == action.payload);

			newState.my.profile.advisorId = action.payload;
			newState.my.profile.advisorName = advisor.name;
			newState.my.profile.advisorUnlimited = advisor.unlimited;
			newState.my.profile.advisorPlan = advisor.plan;

			return newState;
		}

		case Types.ADVISORS_GET_BILLING_EMAILS: {
			let newState = _.cloneDeep(state);

			newState.advisors.billingEmails = action.payload;

			return newState;
		}
		case Types.ADVISORS_PAYMENT_MODAL: {

		  const newState = {...state};

		  newState.payment.advisorModal = action.status
		  newState.payment.isNew = action.isNew

		  if (!action.status){
			delete newState.payment.creditId;
		  }

		  return newState;
		}

		default:
			return state;
	}
};

export default advisorReducers;
